/// <amd-module name="Repos/Views/FilesHub/Components/FolderListing" />
import * as React from "react";
import { FolderListing } from "Repos/FilesHubCommon/Components/FolderListing";
import { IFilesHubFilterActionsService } from "Repos/FilesHubCommon/FilesHubFilterActionsService";
import * as Resources from "Repos/Views/FilesHub/Resources";
import { HeaderCommandBar } from "VSSUI/HeaderCommandBar";
import { getFilesHubViewService, registerFilesHubTab } from "../FilesHubViewService";

registerFilesHubTab({
    getTab: (pageContext, item) => {
        if (item.isFolder && !item.isInvalid) {
            const actionService = pageContext.getService<IFilesHubFilterActionsService>("IFilesHubFilterActionsService");

            return {
                id: "contents",
                name: Resources.Contents,
                order: 10,
                render: () => {
                    return <FolderListing commentsHeaderTitle={Resources.Commits} filesService={getFilesHubViewService(pageContext)} />;
                },
                renderFilterBar: (inTabBar: boolean) => {
                    return inTabBar ? <HeaderCommandBar items={actionService.getActions()} /> : undefined;
                }
            };
        }
    }
});
